/**
 * Saves or loads data
 */
export default class Store {
	/**
	 * Saves data
	 * @param key The unique key to use for this data 
	 * @param value The value to save
	 */
	public set(key: string, value: any): void {
		localStorage.setItem(key, typeof value === 'object' ? JSON.parse(value) : value.toString());
	}

	/**
	 * Retrieves previously saved data
	 * @param key The key it was saved with
	 */
	public get(key: string): string {
		return localStorage.getItem(key) as string;
	}
}
